import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'sc-gpdr-info-redirect-sheet',
  styleUrls: ['./gpdr-info-redirect-sheet.component.scss'],
  encapsulation: ViewEncapsulation.None,
  template: `
    <div class="container">
      <button type="button" class="close-btn" (click)="onClose()">
        <sc-icon name="close"></sc-icon>
        <span class="sr_only">{{
          'GlobalApplicativeConstants.accessibility.closeDialog'
            | translate
              : { dialogTitle: 'GpdrInfoRedirect.mainTitle' | translate }
        }}</span>
      </button>
      <h1
        class="sc-design-text-2"
        id="gpdr-info-redirect-title-id"
        mat-dialog-title
      >
        {{ 'GpdrInfoRedirect.mainTitle' | translate }}
      </h1>
      <div
        [innerHTML]="
          'GpdrInfoRedirect.mainText'
            | translate: { redirectUrl: this.redirectUrl }
        "
      ></div>
    </div>
  `,
  imports: [IconComponent, TranslateModule],
})
export class GpdrInfoRedirectSheetComponent {
  @Input() redirectUrl: string;
  @Output() closeEvent = new EventEmitter<void>();

  onClose() {
    this.closeEvent.emit();
  }
}
